export function bodyTag(n) {
  // n = router name
  document.querySelector("body").removeAttribute("route");
  document.querySelector("body").setAttribute("route", n);

  //to do: document.title = document.querySelector("h1 span").innerText();

  return;
}
